<style lang="stylus">
    .EditSymbol-mask
        modal-mask()
        .EditSymbol-modal

            .EditSymbol-container
                .EditSymbol-line
                    display flex
                    justify-content space-around
                    margin-bottom 10px
                    .input-box
                        width 250px
                    >p
                        width 85px
                        text-align left
                        line-height 24px
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                .EditSymbol-import
                    display flex
                    justify-content space-around
                    margin-bottom 10px
                    .import-showTitle
                        width 85px
                        text-align left
                        line-height 24px
                    .import-showText
                        width 176px
                        height 24px
                        line-height 24px
                        text-indent 10px
                        border 1px solid var(--border-color-library-modal-btn)
                        border-radius 3px
                        overflow hidden
                    .import-btn
                        width 71px
                        height 24px
                        border 1px solid var(--border-color-library-modal-btn)
                        border-radius 3px
                        text-align center
                        line-height 24px
                        font-size 12px
                        cursor pointer
                        user-select none
                        &:hover
                            background-color var(--bg-color-library-btn-import-hover)
                    input
                        display none
</style>

<template>
    <div class="EditSymbol-mask">
        <Dialog class="EditSymbol-modal" :title="$t('title')" :isShow="true" @close="closeModal">
            <div class="EditSymbol-container">
                <div class="EditSymbol-line">
                    <p :title="$t('name')">{{ $t("name") }}:</p>
                    <Input class="input-box" v-model="symbolName" size="small" />
                </div>

                <div class="EditSymbol-import">
                    <p class="import-showTitle">{{ $t("imgfile") }}:</p>
                    <div ref="imgText" class="import-showText"></div>
                    <div class="import-btn" @click="importBtn('img')">{{ $t("importBtn") }}</div>
                    <input ref="imgImporter" type="file" accept=".jpg,.png,.jpeg" @change="getImg($event)" />
                </div>
                <div class="EditSymbol-import">
                    <p class="import-showTitle">{{ $t("edefile") }}:</p>
                    <div ref="edeText" class="import-showText"></div>
                    <div class="import-btn" @click="importBtn('ede')">{{ $t("importBtn") }}</div>
                    <input ref="edeImporter" type="file" accept=".ede" @change="getEde($event)" />
                </div>
            </div>

            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import Dialog from "../Dialog.vue";
    import { isEmpty } from "@/public/utils/tool";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class EditSymbol extends Vue {
        symbolName: string = "";
        imgFile: any;
        edeFile: any;
        worker: any;
        userWorkerURL: string = appConfig.userWorkerURL;
        importBtn(type) {
            let img = this.$refs.imgImporter as HTMLInputElement;
            let ede = this.$refs.edeImporter as HTMLInputElement;
            (type == "img" && (img.click(), true)) || ede.click();
        }
        getImg(e) {
            let img = this.$refs.imgText as HTMLElement;
            img.innerHTML = e.target.files[0].name;
            this.imgFile = e.target.files[0];
            e.target.value = null;
        }
        getEde(e) {
            let ede = this.$refs.edeText as HTMLElement;
            ede.innerHTML = e.target.files[0].name;
            this.edeFile = e.target.files[0];
            e.target.value = null;
        }
        reflashLibrary() {
            // 通知library刷新列表
            let dbName = this.dbAndTable[0];
            let tableName = this.dbAndTable[1];
            let tableID = this.dbAndTable[2];
            let ts: any = this;
            ts.$bus.$emit("setLibrary", {
                type: "updateLibrary",
                groupName: dbName,
                tableID: tableID,
            });
        }
        dataURLtoBlob(dataurl) {
            var arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        }
        addSymbolToDB() {
            let currentID = 0; // 现在表格数据条数
            let promistList = [];
            let dbObj = {
                parent: this.dbAndTable[1],
            };
            dbObj[`${this.lang}_name`] = this.symbolName;
            dbObj[`name`] = this.symbolName;
            let dbName = this.dbAndTable[0];
            let tableName = this.dbAndTable[1];
            let targetID = this.libClickObj.nowItem;
            let data = {
                clickIndex: this.libClickObj.clickIndex,
                ID: this.libClickObj.ID,
            };
            // ede
            if (this.edeFile) {
                let reader = new FileReader();
                reader.readAsText(this.edeFile);
                let promise = new Promise((resolve, reject) => {
                    reader.onload = (e) => {
                        let dataArr = (<any>e.target).result.match(/\<\!\-\-([\s\S]*?)\-\-\>/g);
                        if (dataArr.length) {
                            dbObj["data"] = dataArr[0].replace(/(<!--)|(-->)/g, "");
                        }
                        resolve();
                    };
                });
                promistList.push(promise);
            }
            // img file to blob
            if (this.imgFile) {
                let reader2 = new FileReader();
                reader2.readAsDataURL(this.imgFile);
                let promise2 = new Promise((resolve, reject) => {
                    reader2.onload = (e) => {
                        let blob = this.dataURLtoBlob((e.target as FileReader).result);
                        dbObj["blob"] = blob;
                        resolve();
                    };
                });
                promistList.push(promise2);
            }

            Promise.all(promistList).then(() => {
                let userInfo = this.$store.state.user.userInfo;
                let ossList = this.$store.state.library.ossList;

                this.worker = new Worker(this.userWorkerURL);
                this.worker.postMessage({
                    type: "update",
                    urls: this.urls,
                    data: {
                        DBName: dbName,
                        tableName: tableName,
                        nowItem: targetID,
                        updateType: "editSymbol",
                        tableID: this.dbAndTable[2],
                        dbObj,
                        versionDB: `myDBVersion_${userInfo.user_id}`,
                    },
                });
                this.worker.onmessage = (e) => {
                    let message = e.data;
                    if (message.type === "editOK") {
                        let ts: any = this;
                        this.reflashLibrary();
                        if (!isEmpty(this.libClickObj.ID)) {
                            this.$bus.$emit("updateSearchSymbol", Object.assign({}, data, dbObj));
                            ts.$bus.$asyncEmit("uploadToCloud", { message }).then((e: any) => {
                                let version = e.data.version;
                                this.worker.postMessage({
                                    type: "setVersion",
                                    urls: this.urls,
                                    data: {
                                        versionDB: `myDBVersion_${userInfo.user_id}`,
                                        tableID: this.dbAndTable[2],
                                        version,
                                        params: {
                                            updateModified: true,
                                        },
                                    },
                                });
                            });
                        }
                    } else if (message.type === "setVersionOK") {
                        this.worker.terminate();
                    }
                };
            });
        }
        confirm() {
            this.addSymbolToDB();
            this.closeModal();
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        mounted() {}

        created() {
            this.symbolName = this.selectLibraryShape.langName ? this.selectLibraryShape.langName : this.selectLibraryShape.name;
        }
        get dbAndTable() {
            return this.$store.state.ui.selectLibrary;
        }
        get libClickObj() {
            return this.$store.state.ui.libClickObj;
        }
        get selectLibraryShape() {
            return this.$store.state.ui.selectLibraryShape;
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "编辑符号",
    "name": "符号名称",
    "imgfile": "图片文件",
    "edefile": "ede文件",
    "importBtn": "浏览",
    "confirm": "确定",
    "cancel": "取消"
  },
  "en": {
    "title": "Edit Symbol",
    "name": "Name",
    "imgfile": "Images",
    "edefile": "*.ede",
    "importBtn": "Browse",
    "confirm": "OK",
    "cancel": "Cancel"
  },
  "fr": {
    "title": "Modifier le Symbole",
    "name": "Nom Symbolique",
    "imgfile": "Fichier Image",
    "edefile": "Fichier ede",
    "importBtn": "Parcourir",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "de": {
    "title": "Symbole bearbeiten",
    "name": "Symbolsname",
    "imgfile": "Bilder",
    "edefile": "*.ede Datei",
    "importBtn": "Browsen",
    "confirm": "Sichern",
    "cancel": "Abbrechen"
  },
  "jp": {
    "title": "図形を編集",
    "name": "名称",
    "imgfile": "画像ファイル",
    "edefile": "edeファイル",
    "importBtn": "参照",
    "confirm": "OK",
    "cancel": "キャンセル"
  },
  "es": {
    "title": "Editar símbolo",
    "name": "Nombre de símbolo",
    "imgfile": "Nombre de Imágenes",
    "edefile": "Alchivo.ede",
    "importBtn": "Examinar",
    "confirm": "Aceptar",
    "cancel": "Cancelar"
  },
  "pt": {
    "title": "Editar Símbolo",
    "name": "Nome",
    "imgfile": "Imagens",
    "edefile": "*.ede",
    "importBtn": "Navegar",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "title": "Modifica Simbolo",
    "name": "Nome",
    "imgfile": "Immagini",
    "edefile": "*.ede",
    "importBtn": "Sfoglia",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "title": "編輯符號",
    "name": "符號名稱",
    "imgfile": "圖片檔案",
    "edefile": "ede檔案",
    "importBtn": "瀏覽",
    "confirm": "確定",
    "cancel": "取消"
  },
  "kr": {
    "title": "심볼 편집",
    "name": "심볼 이름",
    "imgfile": "사진 파일 ",
    "edefile": "ede 파일 ",
    "importBtn": "브라우즈",
    "confirm": "확인 ",
    "cancel": "취소 "
  }
}
</i18n>
